import { render, staticRenderFns } from "./SpectroPage.vue?vue&type=template&id=2c49dedd&scoped=true&"
import script from "./SpectroPage.vue?vue&type=script&lang=js&"
export * from "./SpectroPage.vue?vue&type=script&lang=js&"
import style0 from "./SpectroPage.vue?vue&type=style&index=0&id=2c49dedd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49dedd",
  null
  
)

export default component.exports